module.exports = __webpack_public_path__ + "static/img/fun3.d3efd654.png";